import React, { useEffect, useState } from 'react'
import { FiDownload, FiRefreshCw } from 'react-icons/fi'
import { Lock, LockOpen } from '@mui/icons-material'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import CloseIcon from '@mui/icons-material/Close'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BadgeIcon from '@mui/icons-material/Badge'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import InfoIcon from '@mui/icons-material/Info'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import BlockIcon from '@mui/icons-material/Block'
import VerifiedIcon from '@mui/icons-material/Verified'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt'
import NoAccountsIcon from '@mui/icons-material/NoAccounts'
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CheckIcon from '@mui/icons-material/Check'
import PersonIcon from '@mui/icons-material/Person'
import ClearIcon from '@mui/icons-material/Clear'
import Box from '@mui/material/Box'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import dayjs from 'dayjs'
import api from '@/services/api'
import Notfound from '../../../Notfound'
import { TableShimmer } from '../../../ShimmerUI'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Pagination,
  Tooltip,
  TextField,
  InputAdornment,
  Grid,
  Divider,
  Chip,
  Avatar,
  Card,
  CardContent,
  Typography,
  Alert,
  Stack,
} from '@mui/material'
import PercentIcon from '@mui/icons-material/Percent'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import RowsPerPageDropdown from '../RowsPerPageDropdown'
import { ProviderDetailsDialog } from '@/components/provider-details'
import TablePopup from './CommonComponent/TablePopup'
import AgencyDetailsDialog from './AgencyDetailsDialog'
const AgencyManagementPage: React.FC = () => {
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [pageSize, setPageSize] = useState(10)
  const [services, setServices] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loadingForShimmer, setLoadingForShimmer] = useState(true)
  const [therapists, setTherapists] = useState([])



  const [error, setError] = useState('')
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [selectedAccountStatus, setSelectedAccountStatus] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [licenseExpiryDate, setLicenseExpiryDate] = useState<Date | null>(null)

  const [totalRecords, setTotalRecords] = useState(0)
  const [totalActiveRecords, setTotalActiveRecords] = useState(0)
  const [totalInactiveRecords, setTotalInactiveRecords] = useState(0)
  const [openToggle, setOpenToggle] = useState(false) // Dialog open state
  const [sortField, setSortField] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')
  const [selectedTherapistId, setSelectedTherapistId] = useState<string | null>(
    null
  ) // Selected therapist's ID
  const [isActive, setIsActive] = useState<boolean>(false) // Current status of the therapist
  const [loading, setLoading] = useState<boolean>(false) // Loading state during API request
  const [exportLoading, setExportLoading] = useState<boolean>(false) // Loading state for export
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false) // Commission dialog state
  const [monthlyCommission, setMonthlyCommission] = useState<string>('') // Monthly commission value
  const [yearlyCommission, setYearlyCommission] = useState<string>('') // Yearly commission value
  const [providerFeeDiscountPercent, setProviderFeeDiscountPercent] =
    useState<string>('') // Provider fee discount percentage
  const [commissionLoading, setCommissionLoading] = useState<boolean>(false) // Loading state for commission update
  const [openVerificationDialog, setOpenVerificationDialog] = useState(false) // Verification dialog state
  const [selectedProvider, setSelectedProvider] = useState<any>(null) // Selected provider for verification
  const [approveLoading, setApproveLoading] = useState<boolean>(false) // Loading state for approve action
  const [blockLoading, setBlockLoading] = useState<boolean>(false) // Loading state for block action
  const [openBlockReasonDialog, setOpenBlockReasonDialog] = useState(false) // Block reason dialog state
  const [blockReason, setBlockReason] = useState<string>('') // Block reason text
  const [openProviderDetailsDialog, setOpenProviderDetailsDialog] =
    useState(false) // Provider details (read-only) dialog state
  const [selectedProviderForDetails, setSelectedProviderForDetails] =
    useState<any>(null) // Selected provider for details view
  const [openReverifyDialog, setOpenReverifyDialog] = useState(false) // Re-verification dialog state
  const [reverifyProviderId, setReverifyProviderId] = useState<string | null>(
    null
  )
  const [reverifyProviderName, setReverifyProviderName] = useState<string>('')
  const [reverifyLoading, setReverifyLoading] = useState<boolean>(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [selectedProviderForDelete, setSelectedProviderForDelete] =
    useState<any>(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [commissionData, setCommissionData] = useState<any>(null)
  const [enrollmentStatus, setEnrollmentStatus] = useState<string>('')
  const [openTablePopup, setOpenTablePopup] = useState(false)
  const [tableData, setTableData] = useState<any>(null)
  const [tableTitle, setTableTitle] = useState<string>('')
  const handleEnrollmentStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setEnrollmentStatus(e.target.value)
  }
  //finalperclaimfee show only two decimal point
  const finalperclaimfee = Number(monthlyCommission) - Number(providerFeeDiscountPercent);
  const finalperclaimfeeDisplay = finalperclaimfee.toFixed(2);
  const handleExport = async () => {
    setExportLoading(true)
    try {
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      const response = await api.get('admin/agencies/export', {
        responseType: 'blob',
        params,
      })

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: String(response.headers['content-type'] || 'text/csv'),
      })

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Get filename from Content-Disposition header or use default
      // const contentDisposition = response.headers['content-disposition']
      let filename = 'providers_export.csv'
      // if (contentDisposition) {
      //   const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i)
      //   if (filenameMatch) {
      //     filename = filenameMatch[1]
      //   }
      // }

      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      toast.success('Export completed successfully')
    } catch (error) {
      console.error('Error exporting providers:', error)
      toast.error('Failed to export providers data')
    } finally {
      setExportLoading(false)
    }
  }

  const getFormattedDateForAPI = (date: Date | null): string | null => {
    if (!date) return null

    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return `${year}-${month}-${day}` // YYYY-MM-DD format
  }
  const handleAccountStatusChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountStatus(event.target.value)
  }

  const handleOpenToggle = (providerId: string, currentStatus: boolean) => {
    setSelectedTherapistId(providerId) // Set the selected therapist to toggle
    setIsActive(currentStatus) // Set the current status of the therapist (active or inactive)
    setOpenToggle(true) // Open the confirmation dialog
  }

  const handleConfirmToggle = async () => {
    if (!selectedTherapistId) return // Exit if no therapist is selected
    setLoading(true) // Start loading

    const newStatus = !isActive // Toggle the status
    try {
      const response = await api.patch(
        `/admin/agency/${selectedTherapistId}/status`,
        { isActive: newStatus }
      )

      if (response.status === 200) {
        setIsActive(newStatus) // Toggle status locally
        toast.success(
          `Agency status updated to ${newStatus ? 'Active' : 'Inactive'}`
        )
      }

      setOpenToggle(false) // Close the dialog after success
      fetchTherapists() // Optionally refresh the therapist list
    } catch (error) {
      console.error('Error updating the provider status:', error)
      toast.error('Failed to update provider status')
    } finally {
      setLoading(false) // Stop loading
    }
  }

  const handleOpenDeleteDialog = (therapist: any) => {
    setSelectedProviderForDelete(therapist)
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = () => {
    if (!deleteLoading) {
      setOpenDeleteDialog(false)
      setSelectedProviderForDelete(null)
    }
  }

  const handleConfirmDelete = async () => {
    if (!selectedProviderForDelete?._id) return

    setDeleteLoading(true)
    try {
      await api.delete(`admin/agency/${selectedProviderForDelete._id}`)
      toast.success('Agency deleted successfully')
      handleCloseDeleteDialog()
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error deleting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to delete provider')
    } finally {
      setDeleteLoading(false)
    }
  }

  // const handleOpenCommissionDialog = (therapist: any) => {
  //   setSelectedTherapistId(therapist._id)
  //   setMonthlyCommission(therapist.commission?.toString() || '')
  //   setProviderFeeDiscountPercent(
  //     therapist.providerFeeDiscountPercent?.toString() || ''
  //   )
  //   setCommissionData(therapist)

  //   console.log('commissionData', therapist)
  //   setOpenCommissionDialog(true)
  // }

  const handleCloseCommissionDialog = () => {
    setOpenCommissionDialog(false)
    setSelectedTherapistId(null)
    setMonthlyCommission('')
    setYearlyCommission('')
    setProviderFeeDiscountPercent('')
    setCommissionData(null)
  }

  const handleUpdateCommission = async () => {
    if (!selectedTherapistId) return

    // Validate inputs
    if (!monthlyCommission.trim()) {
      toast.error('Please enter both monthly and yearly commission values')
      return
    }
    if (finalperclaimfee <= 0) {
      toast.error('The entered percentages result in a platform fee of 0 or less. Please update the values to maintain a minimum positive fee.')
      return
    }


    const commission = parseFloat(monthlyCommission)
    const discountValue = providerFeeDiscountPercent.trim()
      ? parseFloat(providerFeeDiscountPercent)
      : 0

    if (
      isNaN(commission) ||
      commission < 0
    ) {
      toast.error('Please enter valid commission values (numbers >= 0)')
      return
    }

    if (
      providerFeeDiscountPercent.trim() &&
      (isNaN(discountValue) || discountValue < 0 || discountValue > 100)
    ) {
      toast.error('Please enter a valid discount percentage (0-100)')
      return
    }

    setCommissionLoading(true)
    try {
      const response = await api.patch(
        `/admin/agency/${selectedTherapistId}/commission`,
        {
          commission: commission,
          providerFeeDiscountPercent: discountValue,
        }
      )

      if (response.status === 200) {
        toast.success('Commission updated successfully')
        handleCloseCommissionDialog()
        fetchTherapists(1) // Refresh the therapist list
        setCurrentPage(1)
      }
    } catch (error: any) {
      console.error('Error updating commission:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to update commission'
      )
    } finally {
      setCommissionLoading(false)
    }
  }

  // const handleOpenVerificationDialog = (therapist: any) => {
  //   setSelectedProvider(therapist)
  //   setOpenVerificationDialog(true)
  // }

  const handleCloseVerificationDialog = () => {
    setOpenVerificationDialog(false)
    setSelectedProvider(null)
  }

  const handleOpenProviderDetailsDialog = (therapist: any) => {
    setSelectedProviderForDetails(therapist)
    setOpenProviderDetailsDialog(true)
  }

  const handleCloseProviderDetailsDialog = () => {
    setOpenProviderDetailsDialog(false)
    setSelectedProviderForDetails(null)
  }

  const handleApproveTherapist = async () => {
    if (!selectedProvider?._id) return

    setApproveLoading(true)
    try {
      const response = await api.post(
        `/agency/${selectedProvider._id}/approve`
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseVerificationDialog()
        fetchTherapists() // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error approving provider:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to approve provider'
      )
    } finally {
      setApproveLoading(false)
    }
  }

  const handleOpenBlockReasonDialog = () => {
    setBlockReason('')
    setOpenBlockReasonDialog(true)
  }

  const handleCloseBlockReasonDialog = () => {
    setOpenBlockReasonDialog(false)
    setBlockReason('')
  }

  const handleConfirmBlock = async () => {
    if (!selectedProvider?._id) return

    if (!blockReason.trim()) {
      toast.error('Please provide a reason for blocking the provider')
      return
    }

    setBlockLoading(true)
    try {
      const response = await api.post(
        `/agency/${selectedProvider._id}/block`,
        {
          reason: blockReason.trim(),
        }
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseBlockReasonDialog()
        handleCloseVerificationDialog()
        fetchTherapists() // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error blocking provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to block provider')
    } finally {
      setBlockLoading(false)
    }
  }

  // const handleOpenReverifyDialog = (therapist: any) => {
  //   setReverifyProviderId(therapist?._id || null)
  //   setReverifyProviderName(
  //     therapist
  //       ? `${therapist?.firstName || ''} ${therapist?.lastName || ''}`.trim()
  //       : ''
  //   )
  //   setOpenReverifyDialog(true)
  // }

  const handleCloseReverifyDialog = () => {
    setOpenReverifyDialog(false)
    setReverifyProviderId(null)
    setReverifyProviderName('')
  }

  const handleReverifyProvider = async () => {
    if (!reverifyProviderId) return

    setReverifyLoading(true)

    try {
      const response = await api.get(
        `/agreements/signed/agency-verification/${reverifyProviderId}`
      )

      const message =
        response?.data?.message ||
        'Agency re-verification request completed successfully'

      toast.success(message)

      // Refresh the therapist list to reflect any potential changes
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error during provider re-verification:', error)

      const message =
        error?.response?.data?.message || 'Failed to re-verify provider'

      toast.error(message)
    } finally {
      setReverifyLoading(false)
      handleCloseReverifyDialog()
    }
  }

  const formatDateMMDDYY = (date: string | Date | null | undefined) => {
    if (!date) return '--'
    const dayjsDate = dayjs(date)
    if (!dayjsDate.isValid()) return '--'
    return dayjsDate.format('MM/DD/YYYY')
  }
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
    fetchTherapists(page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    sessionStorage.setItem('prevSize', newPageSize.toString())
  }
  const fetchTherapists = async (page?: number) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
        page: page || 1, // Default to 1 if page is not provided
        limit: pageSize,
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (enrollmentStatus) {
        params.enrollmentStatus = enrollmentStatus
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      // Add sorting parameters
      if (sortField) {
        params.sortField = sortField
        params.sortOrder = sortOrder
      }

      // Make the API call with params
      const response = await api.get('admin/agencies', {
        params,
      })

      // Check if data exists and set the therapists state
      if (response?.data?.data) {
        setTherapists(response.data.data)
      } else {
        setError('No agencies data found')
      }
      setTotalRecords(response?.data?.stats?.totalAgencys)
      setTotalActiveRecords(response?.data?.stats?.totalActiveAgencys)
      setTotalInactiveRecords(response?.data?.stats?.totalInactiveAgencys)
      setTotalPages(Math.ceil(response?.data?.totalRecords / pageSize) || 1)
    } catch (err: any) {
      console.error(err)
      setError('Failed to fetch providers')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }
  const handleReset = () => {
    setSearchKeyword('')
    setSelectedAccountStatus('')
    setStartDate(null)
    setEndDate(null)
    setLicenseExpiryDate(null)
    setSortField('')
    setSortOrder('asc')
    setEnrollmentStatus('')
  }

  const handleSort = (field: string) => {
    if (sortField === field) {
      // Toggle sort order if same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // Set new field and default to ascending
      setSortField(field)
      setSortOrder('asc')
    }
  }

  const getSortIcon = (field: string) => {
    if (sortField !== field) {
      return <UnfoldMoreIcon className="w-4 h-4 ml-1" />
    }
    return sortOrder === 'asc' ? (
      <KeyboardArrowUpIcon className="w-4 h-4 ml-1" />
    ) : (
      <KeyboardArrowDownIcon className="w-4 h-4 ml-1" />
    )
  }


  useEffect(() => {

    fetchTherapists(currentPage)
  }, [
    searchKeyword,
    selectedAccountStatus,
    startDate,
    endDate,
    licenseExpiryDate,
    sortField,
    sortOrder,
    pageSize,
    currentPage,
    enrollmentStatus
  ])
  return (
    <div className="p-6 mx-auto max-w-7xl">

      <div className="flex flex-col items-start justify-between gap-4 mb-4 sm:flex-row sm:items-center">
        <h1 className="text-2xl font-semibold text-[#6E7B8B]">
          Agency Management
        </h1>
        <button
          className="flex items-center gap-2 px-4 py-2 text-white bg-[#5BC0BE] border border-gray-300 rounded-lg hover:bg-[#49a9a7] disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleExport}
          disabled={exportLoading}
          style={{
            cursor: exportLoading ? 'not-allowed' : 'pointer',
          }}
        >
          <FiDownload className="w-4 h-4" />
          {exportLoading ? 'Exporting...' : 'Export CSV'}
        </button>
      </div>

      <Card
        sx={{
          height: '100%',
          cursor: 'pointer',
          boxShadow: 2,
          padding: 2,
          mb: 3,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
        <CardContent>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-6">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Search Agency
              </label>
              <input
                type="text"
                value={searchKeyword}
                onChange={e => setSearchKeyword(e.target.value)}
                placeholder="Search agency"
                className="w-full border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Account Status
              </label>
              <select
                id="accountStatus"
                value={selectedAccountStatus}
                onChange={handleAccountStatusChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              >
                <option value="" disabled selected>
                  Select Status
                </option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            {/* <Box>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Enrollment Status
              </label>
              <select
                id="accountStatus"
                value={enrollmentStatus}
                onChange={handleEnrollmentStatusChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
              >
                <option value="" disabled selected>
                  Select Status
                </option>
                <option value="true">Enrolled</option>
                <option value="false">Not Enrolled</option>
              </select>
            </Box> */}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box display="flex" alignItems="flex-start" gap={2} width="100%">
                <Box>
                  <Typography variant="body2" mb={0.5}>
                    Start Date
                  </Typography>
                  <DatePicker
                    value={startDate}
                    onChange={(newValue: Date | null) => setStartDate(newValue)}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: false,
                        sx: { width: '150px' },
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography variant="body2" mb={0.5}>
                    End Date
                  </Typography>
                  <DatePicker
                    value={endDate}
                    onChange={(newValue: Date | null) => setEndDate(newValue)}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: false,
                        sx: { width: '150px' },
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography variant="body2" mb={0.5}>
                    License Expiry
                  </Typography>
                  <DatePicker
                    value={licenseExpiryDate}
                    onChange={(newValue: Date | null) =>
                      setLicenseExpiryDate(newValue)
                    }
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: false,
                        sx: { width: '150px' },
                      },
                    }}
                  />
                </Box>


                {/* Reset All Button */}
                <Box display="flex" alignItems="center">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleReset}
                    sx={{
                      borderRadius: 2,
                      marginTop: '28px',
                    }}
                  >
                    {/* reset icon */}
                    <FiRefreshCw className="w-4 h-4" />
                  </Button>
                </Box>
              </Box>
            </LocalizationProvider>
          </div>
        </CardContent>
      </Card>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-3">
        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow h-35">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">{totalRecords}</h2>
            <p className="text-sm text-gray-500">Total Agencies</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-green-600 bg-green-100 rounded-full">
            <PersonIcon />
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {totalActiveRecords}
            </h2>
            <p className="text-sm text-gray-500">Active Accounts</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-blue-600 bg-blue-100 rounded-full">
            <CheckIcon />
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {totalInactiveRecords}
            </h2>
            <p className="text-sm text-gray-500">InActive Accounts</p>
          </div>
          <div className="flex items-center justify-center w-12 h-12 text-xl font-bold text-red-600 bg-red-100 rounded-full">
            <ClearIcon />
          </div>
        </div>
      </div>

      {/* Therapist Table */}
      <div className="overflow-hidden bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="text-sm text-left text-white uppercase bg-[#5BC0BE]">
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('firstName')}
                >
                  <div className="flex items-center">
                    Name
                    {getSortIcon('firstName')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('email')}
                >
                  <div className="flex items-center">
                    Email
                    {getSortIcon('email')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('phone')}
                >
                  <div className="flex items-center">
                    Phone
                    {getSortIcon('phone')}
                  </div>
                </th>
                <th
                  className="px-6 py-3 font-medium cursor-pointer"
                  onClick={() => handleSort('createdAt')}
                >
                  <div className="flex items-center">
                    Onboarding
                    {getSortIcon('createdAt')}
                  </div>
                </th>
                <th className="px-6 py-3 font-medium">License No</th>
                <th className="px-6 py-3 font-medium">License Expiration</th>
                <th className="px-6 py-3 font-medium">Accepted Insurances</th>
                <th className="px-6 py-3 font-medium">Account Status</th>
                <th className="px-6 py-3 font-medium text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loadingForShimmer ? (
                <TableShimmer columns={11} />
              ) : therapists?.length === 0 ? (
                <tr>
                  <td colSpan={20} className="p-4 text-center">
                    <Notfound />
                  </td>
                </tr>
              ) : (
                therapists.map(therapist => (
                  <tr
                    key={therapist._id}
                    className="transition-colors hover:bg-gray-50"
                  >
                    <td className="px-6 py-4 min-w-[200px]">
                      <div className="flex items-center gap-2">
                        <Tooltip title="View Agency Details" arrow placement="top">
                          <span
                            role="button"
                            tabIndex={0}
                            onClick={() =>
                              handleOpenProviderDetailsDialog(therapist)
                            }
                            onKeyDown={e => {
                              if (e.key === 'Enter' || e.key === ' ')
                                handleOpenProviderDetailsDialog(therapist)
                            }}
                            className="cursor-pointer font-medium text-[#5BC0BE] hover:text-[#4a9d9b] hover:underline focus:outline-none focus:underline"
                          >
                            {therapist?.agencyName}
                          </span>
                        </Tooltip>


                      </div>
                    </td>
                    <td className="px-6 py-4">{therapist?.companyEmail}</td>
                    <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.companyPhone}
                    </td>


                    <td className="px-6 py-4">
                      {formatDateMMDDYY(therapist?.createdAt) || '--'}
                    </td>
                    <td className="px-6 py-4 min-w-[280px]">
                      {therapist?.licenses && therapist.licenses.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {therapist.licenses
                            .filter((license: any) => license.licenseNumber)
                            .map((license: any, index: number) => (
                              <span
                                key={index}
                                className="px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 border border-blue-200 rounded-full"
                              >
                                {license.licenseNumber}
                              </span>
                            ))}
                        </div>
                      ) : (
                        '--'
                      )}
                    </td>
                    <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.licenses && therapist.licenses.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {therapist.licenses
                            .filter((license: any) => license.expiryDate)
                            .map((license: any, index: number) => {
                              const expiry = new Date(license.expiryDate)
                              if (isNaN(expiry.getTime())) return null
                              const month = expiry.getUTCMonth() + 1
                              const day = expiry.getUTCDate()
                              const year = expiry.getUTCFullYear()
                              const formattedDate = `${month}/${day}/${year}`
                              const isExpired = expiry < new Date()
                              const isExpiringSoon =
                                expiry >= new Date() &&
                                expiry <=
                                new Date(
                                  new Date().setMonth(
                                    new Date().getMonth() + 3
                                  )
                                )

                              return (
                                <span
                                  key={index}
                                  className={`px-2 py-1 text-xs font-medium rounded-full border ${isExpired
                                    ? 'text-red-700 bg-red-100 border-red-200'
                                    : isExpiringSoon
                                      ? 'text-yellow-700 bg-yellow-100 border-yellow-200'
                                      : 'text-green-700 bg-green-100 border-green-200'
                                    }`}
                                >
                                  {formattedDate}
                                </span>
                              )
                            })}
                        </div>
                      ) : (
                        '--'
                      )}
                    </td>
                    <td className="px-6 py-4 min-w-[200px]">
                      {therapist?.insuranceAccepted &&
                        therapist.insuranceAccepted.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {therapist.insuranceAccepted
                            .filter((insurance: any) => insurance.name)
                            .map((insurance: any, index: number) => (
                              <span
                                key={index}
                                className="px-2 py-1 text-xs font-medium text-green-700 bg-green-100 border border-green-200 rounded-full"
                              >
                                {insurance.name}
                              </span>
                            ))}
                        </div>
                      ) : (
                        '--'
                      )}
                    </td>

                    {/* <td>
                      <Chip
                        label={therapist?.enrollmentStatus ? "Enrolled" : "Not Enrolled"}
                        color={therapist?.enrollmentStatus ? "success" : "error"}
                      />
                    </td> */}
                    {/* quiq enrollment button */}
                    {/* <td>

                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setOpenTablePopup(true)
                          setTableTitle('Quick Enroll')
                          setTableData(therapist?.providerInsurance)
                        }}
                      >
                        Quick Enroll
                      </Button>
                    </td> */}
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium border ${therapist?.isActive
                          ? 'border-green-500 text-green-600'
                          : 'border-red-500 text-red-600'
                          }`}
                      >
                        {therapist?.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex items-center justify-center gap-2">
                        {/* <Tooltip title="View Agency Verification" arrow placement="top">
                          <IconButton
                            onClick={() =>
                              handleOpenVerificationDialog(therapist)

                            }
                            size="small"
                            sx={{
                              color: '#5BC0BE',
                              '&:hover': {
                                bgcolor: 'rgba(91, 192, 190, 0.1)',
                              },
                            }}
                          >
                            <VerifiedUserIcon />
                          </IconButton>
                        </Tooltip> */}
                        {/* <Tooltip title="Re-Verify Agency" arrow placement="top">
                          <IconButton
                            onClick={() => handleOpenReverifyDialog(therapist)}
                            size="small"
                            sx={{
                              color: '#10b981',
                              '&:hover': {
                                bgcolor: 'rgba(16, 185, 129, 0.1)',
                              },
                            }}
                          >
                            <AutorenewIcon />
                          </IconButton>
                        </Tooltip> */}

                        <Tooltip title={
                          therapist?.isActive ? 'Deactivate' : 'Activate'
                        }
                          arrow
                          placement="top"
                        >
                          <IconButton
                            onClick={() =>
                              handleOpenToggle(
                                therapist?._id,
                                therapist?.isActive
                              )
                            }
                          >
                            {therapist?.isActive ? (
                              <ToggleOnIcon
                                sx={{ fontSize: 32, color: '#10b981' }}
                              />
                            ) : (
                              <ToggleOffIcon
                                sx={{ fontSize: 32, color: '#ef4444' }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Agency" arrow placement="top">
                          <IconButton
                            onClick={() => handleOpenDeleteDialog(therapist)}
                            size="small"
                            sx={{
                              color: '#dc2626',
                              '&:hover': {
                                bgcolor: 'rgba(220, 38, 38, 0.1)',
                              },
                            }}
                          >
                            <DeleteForeverIcon sx={{ fontSize: 22 }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-center mt-3">
        <div className="flex items-center gap-4">
          <RowsPerPageDropdown
            pageSize={pageSize}
            onPageSizeChange={newPageSize => {
              handlePageSizeChange(newPageSize)
              if (ourPageSize && ourPageSize !== newPageSize) {
                setCurrentPage(1)
              }
            }}
          />
        </div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className="mt-2 mt-md-0"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>
      <ToastContainer />
      <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to {isActive ? 'deactivate' : 'activate'} this
          agency?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenToggle(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Provider Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1.5,
            pt: 2.5,
            px: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: 'error.lighter',
            }}
          >
            <DeleteForeverIcon sx={{ fontSize: 28, color: 'error.main' }} />
          </Box>
          <Box>
            <Typography variant="h6" component="span" fontWeight={600}>
              Delete Agency
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              display="block"
              mt={0.5}
            >
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to permanently delete this agency? All
            associated data will be removed.
          </Typography>
          {selectedProviderForDelete && (
            <Box
              sx={{
                p: 2,
                mb: 2,
                bgcolor: 'grey.50',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Agency name:</strong> {''}
                {selectedProviderForDelete.agencyName}

              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Agency email:</strong> {''}
                {selectedProviderForDelete.companyEmail}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2.5,
            px: 3,
            gap: 1.5,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Button
            onClick={handleCloseDeleteDialog}
            disabled={deleteLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={deleteLoading}
            variant="contained"
            color="error"
            startIcon={
              deleteLoading ? null : <DeleteForeverIcon sx={{ fontSize: 18 }} />
            }
          >
            {deleteLoading ? 'Deleting...' : 'Delete Agency'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openReverifyDialog} onClose={handleCloseReverifyDialog}>
        <DialogTitle>Re-Verify Agency</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 1.5 }}>
            Are you sure you want to initiate re-verification for{' '}
            <strong>{reverifyProviderName || 'this Agency'}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReverifyDialog}
            variant="outlined"
            disabled={reverifyLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReverifyProvider}
            color="primary"
            variant="contained"
            disabled={reverifyLoading}
          >
            {reverifyLoading ? 'Re-verifying...' : 'Confirm Re-Verification'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Commission Dialog */}
      <Dialog
        open={openCommissionDialog}
        onClose={handleCloseCommissionDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Per Claim System Fee & Discount</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',

          }}
        >
          {commissionData?.plan_id?.name && (
            <Typography sx={{ pt: 0.5 }}>
              <strong>Subscribed Plan:</strong> {commissionData?.plan_id?.name}
            </Typography>
          )}
          {commissionData?.plan_id?.monthly_fee && commissionData?.plan_id?.anual_fee && (
            <Typography variant="body1" sx={{ mb: 0.2 }}>
              <strong>Subscription Fee:</strong>{" "}
              {commissionData?.frequency === "Month"
                ? `$${commissionData?.plan_id?.monthly_fee}`
                : `$${commissionData?.plan_id?.anual_fee}`}
            </Typography>
          )}
          {commissionData?.plan_id?.commission && (
            <Typography variant="body1" sx={{ mb: 1.6 }}>
              <strong>Per-Claim System Fee:</strong> {`${commissionData?.plan_id?.commission}%`}
            </Typography>
          )}
          <TextField
            label="Per Claim System Fee"
            type="number"
            value={monthlyCommission}
            sx={{ mb: 1.6, mt: 1.6 }}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : monthlyCommission
                setMonthlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee percentage"
          />
          {/* <TextField
            label="Yearly Commission"
            type="number"
            value={yearlyCommission}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d+(\.\d{0,2})?)?$/)
                  ? inputValue
                  : yearlyCommission
                setYearlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the yearly commission percentage"
          /> */}
          <TextField
            label="Per Claim System Fee Discount"
            type="number"
            value={providerFeeDiscountPercent}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places) between 0-100
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : providerFeeDiscountPercent
                // Check if value is within valid range (0-100)
                if (
                  validValue === '' ||
                  (parseFloat(validValue) >= 0 && parseFloat(validValue) <= 100)
                ) {
                  setProviderFeeDiscountPercent(validValue)
                }
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee Discount (0-100)"
          />

          <Typography variant="body1" sx={{ mb: 1.6, mt: 1.6 }}>
            <strong>Final Per Claim Fee:</strong> {finalperclaimfeeDisplay}%
          </Typography>
          {/* if Final Per Claim Fee less than or equal to 0, show a error message */}
          {finalperclaimfee <= 0 && (
            <Typography variant="body2" color="error">
              The entered percentages result in a platform fee of 0 or less. Please update the values to maintain a minimum positive fee.
            </Typography>
          )}


        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseCommissionDialog}
            disabled={commissionLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateCommission}
            variant="contained"
            color="primary"
            disabled={commissionLoading}
          >
            {commissionLoading ? 'Updating...' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Verification Dialog */}
      <Dialog
        open={openVerificationDialog}
        onClose={handleCloseVerificationDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: '90vh',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
            pt: 3,
            px: 3,
            background: 'linear-gradient(135deg, #5BC0BE 0%, #4a9d9b 100%)',
            color: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <VerifiedUserIcon sx={{ fontSize: 28 }} />
            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, letterSpacing: 0.5 }}
              >
                Agency Verification Details
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={handleCloseVerificationDialog}
            size="small"
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ pt: '1rem !important', pb: 2, px: 3, bgcolor: '#f8f9fa' }}
        >
          {selectedProvider && (
            <>
              <Grid container spacing={3}>

                {/* <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      mb: 2,
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <PersonOutlineIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Profile Information
                        </Typography>
                        {(() => {
                          if (
                            selectedProvider.status?.toLowerCase() === 'blocked'
                          ) {
                            return (
                              <Box
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <Chip
                                  icon={
                                    <NoAccountsIcon sx={{ fontSize: 16 }} />
                                  }
                                  label="Blocked"
                                  sx={{
                                    backgroundColor: 'rgba(211, 47, 47, 0.2)',
                                    color: '#d32f2f',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    height: 28,
                                    border: '1.5px solid #d32f2f',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                    '& .MuiChip-icon': { color: '#d32f2f' },
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                      transform: 'translateY(-1px)',
                                      boxShadow:
                                        '0 4px 12px rgba(0, 0, 0, 0.2)',
                                    },
                                  }}
                                />
                              </Box>
                            )
                          }
                          if (
                            selectedProvider.status?.toLowerCase() === 'active'
                          ) {
                            return (
                              <Box
                                sx={{ display: 'flex', alignItems: 'center' }}
                              >
                                <Chip
                                  icon={<VerifiedIcon sx={{ fontSize: 16 }} />}
                                  label="Approved"
                                  sx={{
                                    backgroundColor: 'rgba(46, 125, 50, 0.2)',
                                    color: '#2e7d32',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    height: 28,
                                    border: '1.5px solid #2e7d32',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                    '& .MuiChip-icon': { color: '#2e7d32' },
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                      transform: 'translateY(-1px)',
                                      boxShadow:
                                        '0 4px 12px rgba(0, 0, 0, 0.2)',
                                    },
                                  }}
                                />
                              </Box>
                            )
                          }
                          return null
                        })()}
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Full Name
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '1rem',
                            }}
                          >
                            {selectedProvider.firstName}{' '}
                            {selectedProvider.lastName}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Email
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.email || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Phone
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.phone || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Gender
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.gender || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Status
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isActive ? 'Active' : 'Inactive'
                            }
                            color={
                              selectedProvider.isActive === true
                                ? 'success'
                                : 'error'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Years of Experience
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.yearsOfExperience || '--'}
                          </Typography>
                        </Grid>
                        {selectedProvider.bio && (
                          <Grid item xs={12}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              Bio
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                mt: 0.5,
                                color: '#495057',
                                lineHeight: 1.7,
                                bgcolor: '#f8f9fa',
                                p: 1.5,
                                borderRadius: 1,
                              }}
                            >
                              {selectedProvider.bio}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <LocationOnIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Address Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Address Line
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.addressLine || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            City
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.city || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            State
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.state || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Zip Code
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.zipCode || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Country
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.country || '--'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

              
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <AccountBalanceIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Billing Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Billing Type
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.billingType
                              ? selectedProvider.billingType
                                  .charAt(0)
                                  .toUpperCase() +
                                selectedProvider.billingType.slice(1)
                              : '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Provider NPI
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.providerNpi || '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Billing NPI
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.billingNpi || '--'}
                          </Typography>
                        </Grid>
                        {selectedProvider.billingType?.toLowerCase() ===
                        'individual' ? (
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              SSN
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#495057',
                                fontSize: '0.95rem',
                              }}
                            >
                              {selectedProvider.ssn || '--'}
                            </Typography>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              Tax ID
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#495057',
                                fontSize: '0.95rem',
                              }}
                            >
                              {selectedProvider.taxId || '--'}
                            </Typography>
                          </Grid>
                        )}
                        {selectedProvider.companyName && (
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#6c757d',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                                fontSize: '0.7rem',
                                mb: 0.5,
                                display: 'block',
                              }}
                            >
                              Company Name
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#495057',
                                fontSize: '0.95rem',
                              }}
                            >
                              {selectedProvider.companyName}
                            </Typography>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Billing Phone
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: '#495057',
                              fontSize: '0.95rem',
                            }}
                          >
                            {selectedProvider.billingPhone || '--'}
                          </Typography>
                        </Grid>
                        {selectedProvider.billingAddressLine && (
                          <>
                            <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: '#6c757d',
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  letterSpacing: 0.5,
                                  fontSize: '0.7rem',
                                  mb: 0.5,
                                  display: 'block',
                                }}
                              >
                                Billing Address
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{
                                  fontWeight: 500,
                                  color: '#495057',
                                  fontSize: '0.95rem',
                                }}
                              >
                                {selectedProvider.billingAddressLine}
                                {selectedProvider.billingCity &&
                                  `, ${selectedProvider.billingCity}`}
                                {selectedProvider.billingState &&
                                  `, ${selectedProvider.billingState}`}
                                {selectedProvider.billingZipCode &&
                                  ` ${selectedProvider.billingZipCode}`}
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid> */}

                {/* Licenses Section */}
                {selectedProvider.licenses &&
                  selectedProvider.licenses.length > 0 && (
                    <Grid item xs={12}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              mb: 3,
                              pb: 2,
                              borderBottom: '2px solid',
                              borderColor: '#5BC0BE',
                            }}
                          >
                            <BadgeIcon
                              sx={{ color: '#5BC0BE', fontSize: 28 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: '#2c3e50',
                                letterSpacing: 0.3,
                              }}
                            >
                              License Information
                            </Typography>
                          </Box>
                          <Grid container spacing={2}>
                            {selectedProvider.licenses.map(
                              (license: any, index: number) => (
                                <Grid item xs={12} key={index}>
                                  <Card
                                    elevation={0}
                                    sx={{
                                      p: 2.5,
                                      borderRadius: 2,
                                      border: '1px solid',
                                      borderColor: '#e9ecef',
                                      bgcolor: '#f8f9fa',
                                    }}
                                  >
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License Number
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 600,
                                            color: '#2c3e50',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.licenseNumber || '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License State
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            color: '#495057',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.licenseState || '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          Expiry Date
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            color: '#495057',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.expiryDate
                                            ? formatDateMMDDYY(
                                              license.expiryDate
                                            )
                                            : '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License Status
                                        </Typography>
                                        <Chip
                                          label={license.licenseStatus || '--'}
                                          color={
                                            license.licenseStatus === 'Active'
                                              ? 'success'
                                              : 'default'
                                          }
                                          size="small"
                                          sx={{
                                            fontWeight: 600,
                                            height: 28,
                                            '& .MuiChip-label': {
                                              px: 1.5,
                                            },
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Grid>
                              )
                            )}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}


                {/* {selectedProvider.insuranceAccepted &&
                  selectedProvider.insuranceAccepted.length > 0 && (
                    <Grid item xs={12}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              mb: 3,
                              pb: 2,
                              borderBottom: '2px solid',
                              borderColor: '#5BC0BE',
                            }}
                          >
                            <HealthAndSafetyIcon
                              sx={{ color: '#5BC0BE', fontSize: 28 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: '#2c3e50',
                                letterSpacing: 0.3,
                              }}
                            >
                              Accepted Insurances
                            </Typography>
                          </Box>
                          <Box
                            sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}
                          >
                            {selectedProvider.insuranceAccepted.map(
                              (insurance: any, index: number) => (
                                <Chip
                                  key={index}
                                  label={insurance.name || '--'}
                                  sx={{
                                    bgcolor: '#e3f2fd',
                                    color: '#1976d2',
                                    fontWeight: 600,
                                    border: '1px solid #90caf9',
                                    '&:hover': {
                                      bgcolor: '#bbdefb',
                                    },
                                  }}
                                  size="medium"
                                />
                              )
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <InfoIcon sx={{ color: '#5BC0BE', fontSize: 28 }} />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Additional Information
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Bank Connected
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isConnectBank ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.isConnectBank
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Subscription Taken
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isSubscriptionTaken
                                ? 'Yes'
                                : 'No'
                            }
                            color={
                              selectedProvider.isSubscriptionTaken
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Service Created
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isServiceCreated ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.isServiceCreated
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Slot Added
                          </Typography>
                          <Chip
                            label={selectedProvider.isSlotAdded ? 'Yes' : 'No'}
                            color={
                              selectedProvider.isSlotAdded
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Accepts New Patients
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.isAcceptNewPatientEnq
                                ? 'Yes'
                                : 'No'
                            }
                            color={
                              selectedProvider.isAcceptNewPatientEnq
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            HIPAA Signed
                          </Typography>
                          <Chip
                            label={
                              selectedProvider.hasSignedHIPAA ? 'Yes' : 'No'
                            }
                            color={
                              selectedProvider.hasSignedHIPAA
                                ? 'success'
                                : 'default'
                            }
                            size="small"
                            sx={{
                              fontWeight: 600,
                              height: 28,
                              '& .MuiChip-label': {
                                px: 1.5,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Onboarding Date
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '0.95rem',
                            }}
                          >
                            {formatDateMMDDYY(selectedProvider.createdAt) ||
                              '--'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#6c757d',
                              fontWeight: 600,
                              textTransform: 'uppercase',
                              letterSpacing: 0.5,
                              fontSize: '0.7rem',
                              mb: 0.5,
                              display: 'block',
                            }}
                          >
                            Last Updated
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              color: '#2c3e50',
                              fontSize: '0.95rem',
                            }}
                          >
                            {formatDateMMDDYY(selectedProvider.updatedAt) ||
                              '--'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid> */}

                {/* Verification Status Section - at end of content */}
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <VerifiedUserIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Verification Status
                        </Typography>
                      </Box>
                      <Stack spacing={0} sx={{ width: '100%' }}>
                        {[
                          {
                            title: 'License Verification',
                            status:
                              selectedProvider.verificationStatus || 'N/A',
                            message:
                              selectedProvider.verificationMessage || '--',
                          },
                          {
                            title: 'FACIS Verification',
                            status:
                              selectedProvider.verificationFacisStatus || 'N/A',
                            message:
                              selectedProvider.verificationFacisMessage || '--',
                          },
                          {
                            title: 'Board Verification',
                            status:
                              selectedProvider.verificationBoardStatus || 'N/A',
                            message:
                              selectedProvider.verificationBoardMessage || '--',
                          },
                        ].map((item, index) => {
                          const getChipStyle = (s: string) => {
                            const sUpper = String(s).toLowerCase()
                            if (sUpper === 'verified')
                              return {
                                // bgcolor: 'rgba(46, 125, 50, 0.12)',
                                color: '#2e7d32',
                                // border: '1px solid rgba(46, 125, 50, 0.5)',
                              }
                            if (sUpper === 'pending')
                              return {
                                // bgcolor: 'rgba(237, 108, 2, 0.12)',
                                color: '#ed6c02',
                                // border: '1px solid rgba(237, 108, 2, 0.5)',
                              }
                            if (sUpper === 'expired' || sUpper === 'rejected')
                              return {
                                // bgcolor: 'rgba(211, 47, 47, 0.12)',
                                color: '#d32f2f',
                                // border: '1px solid rgba(211, 47, 47, 0.5)',
                              }
                            if (sUpper === 'submitted')
                              return {
                                // bgcolor: 'rgba(2, 136, 209, 0.12)', // soft info blue background
                                color: '#0288d1', // info main
                                // border: '1px solid rgba(2, 136, 209, 0.5)',
                              }

                            return {
                              // bgcolor: 'rgba(108, 117, 125, 0.12)',
                              color: '#6c757d',
                              // border: '1px solid rgba(108, 117, 125, 0.3)',
                            }
                          }
                          const chipStyle = getChipStyle(item.status)
                          return (
                            <Box
                              key={item.title}
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 2,
                                py: 1.75,
                                px: 1.5,
                                borderBottom: index < 2 ? '1px solid' : 'none',
                                borderColor: '#e9ecef',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: 180,
                                  flexShrink: 0,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: '#2c3e50',
                                    fontWeight: 700,
                                    fontSize: '0.875rem',
                                    letterSpacing: 0.3,
                                    lineHeight: 1.4,
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    mt: 2,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: '#868e96',
                                      fontWeight: 500,
                                      fontSize: '0.7rem',
                                    }}
                                  >
                                    Status:
                                  </Typography>
                                  {/* <Chip
                                    label={item.status}
                                    size="small"
                                    sx={{
                                      fontWeight: 600,
                                      height: 22,
                                      fontSize: '0.7rem',
                                      ...chipStyle,
                                    }}
                                  /> */}
                                  <Typography variant="caption" sx={{

                                    fontWeight: 800,
                                    fontSize: '0.8rem',
                                    ...chipStyle,
                                  }}>{item.status}</Typography>
                                </Box>
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: '#495057',
                                  fontSize: '0.8125rem',
                                  lineHeight: 1.5,
                                  flex: 1,
                                  pt: 0.25,
                                }}
                              >
                                {item.message}
                              </Typography>
                            </Box>
                          )
                        })}
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Block Reason - at very end of content */}
                {selectedProvider.blockReason && (
                  <Grid item xs={12}>
                    <Alert
                      severity="error"
                      icon={<BlockIcon />}
                      sx={{
                        borderRadius: 2,
                        '& .MuiAlert-message': { width: '100%' },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Block Reason
                      </Typography>
                      <Typography variant="body2">
                        {selectedProvider.blockReason}
                      </Typography>
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </DialogContent>
        {selectedProvider && (
          <>
            <Divider sx={{ borderColor: '#e9ecef' }} />
            <DialogActions
              sx={{
                px: 3,
                py: 2.5,
                bgcolor: '#f8f9fa',
                borderTop: '1px solid',
                borderColor: '#e9ecef',
                justifyContent: 'flex-end',
                gap: 1.5,
              }}
            >
              {selectedProvider.status?.toLowerCase() !== 'active' && (
                <Button
                  onClick={handleApproveTherapist}
                  variant="contained"
                  color="success"
                  disabled={approveLoading || blockLoading}
                  startIcon={<CheckCircleIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                    },
                  }}
                >
                  {approveLoading ? 'Approving...' : 'Approve Agency'}
                </Button>
              )}
              {selectedProvider.status?.toLowerCase() !== 'blocked' && (
                <Button
                  onClick={handleOpenBlockReasonDialog}
                  variant="contained"
                  color="error"
                  disabled={approveLoading || blockLoading}
                  startIcon={<BlockIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
                    },
                  }}
                >
                  Block Agency
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Block Reason Dialog */}
      <Dialog
        open={openBlockReasonDialog}
        onClose={handleCloseBlockReasonDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <BlockIcon sx={{ color: 'error.main', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Block Agency
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: '1rem !important', pb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please provide a reason for blocking this agency. This reason will
            be displayed to the agency in to their account.
          </Typography>
          <TextField
            label="Reason for Blocking"
            multiline
            rows={4}
            fullWidth
            value={blockReason}
            onChange={e => setBlockReason(e.target.value)}
            placeholder="Enter the reason for blocking this agency..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
            helperText={`${blockReason.length} characters`}
          />
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCloseBlockReasonDialog}
            variant="outlined"
            disabled={blockLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmBlock}
            variant="contained"
            color="error"
            disabled={blockLoading || !blockReason.trim()}
            startIcon={<BlockIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
              },
            }}
          >
            {blockLoading ? 'Blocking...' : 'Confirm Block'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Details Dialog (read-only) */}
      <AgencyDetailsDialog
        open={openProviderDetailsDialog}
        onClose={handleCloseProviderDetailsDialog}
        provider={selectedProviderForDetails}
      />
      <TablePopup open={openTablePopup} handleClose={() => setOpenTablePopup(false)} data={tableData} title={tableTitle} />
    </div>
  )
}

export default AgencyManagementPage
